// extracted by mini-css-extract-plugin
export var section = "_1l-1";
export var topNav = "_1l-0";